import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { Config } from "@config";
import { faPaperPlane as fasPaperPlane } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import { FormEmail, List, ProgressButton, generateUrlParams } from "bm-ui-kit";
import type { ProgressButtonState } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Alert, Card } from "react-bootstrap";

interface StepFields {
	email?: string;
}

interface Props extends AbstractStepProps {
	loanGoal: string;
	realEstateValue: number;
	numberOfChildren: number;
	errorMessages: string[];

	submitState: ProgressButtonState;
	leadId: number;
}

export class ResultUnsuitable extends AbstractStep<StepFields, Props> {
	protected renderContent(values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { loanGoal, realEstateValue, numberOfChildren, submitState } = this.props;
		const mortgageUrl = `/lakashitel-kalkulator/?${generateUrlParams({
			loanGoal,
			realEstateValue,
			numberOfChildren,
		})}`;
		const isPartner = Config.isPartner();

		return (
			<>
				<Card.Header className="bg-danger">
					<Card.Title className="text-white">
						A megadott adatok alapján sajnos <strong>nem vagy jogosult</strong> a támogatásra, mert:
					</Card.Title>
				</Card.Header>
				<Card.Body>
					{this.renderResults()}
					<div>
						Ha CSOK helyett hitelből valósítanád meg célod{" "}
						<a href={mortgageUrl}>lakáshitel kalkulátorunkkal</a> megtalálhatod a számodra megfelelőt.
					</div>
					{isPartner && (
						<>
							<hr className="w-75" />
							<div>
								Ha szeretnél tájékoztatást kapni a CSOK változásairól iratkozz fel heti hírlevelünkre,
								ahol rendszeresen foglalkozunk a témával.
							</div>
							<FormEmail name="email" placeholder="E-mail cím" required />
							<div>
								<small>
									A lenti gomb megnyomásával elfogadom az{" "}
									<a
										href={Config.getBankmonitorUrl("/adatvedelem/")}
										// biome-ignore lint/a11y/noBlankTarget: in-page link
										target="_blank"
									>
										adatvédelmi tájékoztatóban
									</a>{" "}
									foglaltakat.
								</small>
							</div>
						</>
					)}
				</Card.Body>
				{isPartner && (
					<Card.Footer className="text-center">
						<ProgressButton
							type="submit"
							icon={<FontAwesomeIcon icon={fasPaperPlane} />}
							disabled={!form.getState().valid}
							state={submitState}
							onClick={() => this.onSubscribeClick(values)}
						>
							Feliratkozás
						</ProgressButton>
					</Card.Footer>
				)}
			</>
		);
	}

	protected onSubscribeClick(values: StepFields): void {
		const { email } = values;

		this.sendEvent("BM_newsletterSubscription", {
			buttonId: GoogleAnalytics4.generateId("bi"),
			productTypes: "CSOK",
			email,
			newsletterType: "general",
			user_data: {
				email_address: email,
			},
		});
	}

	private renderResults(): ReactNode {
		const { errorMessages } = this.props;
		const errors = errorMessages.slice(0, 3);

		return (
			<Alert variant="danger">
				<List itemStyle="warning-triangle" className="mb-0">
					{errors.map((error, key) => (
						<List.Item key={key}>{error}</List.Item>
					))}
				</List>
			</Alert>
		);
	}

	protected getComponentName(): string {
		return "ResultUnsuitable";
	}
}
